<template>
    <div
        class="vx-col-span-12 lg:vx-col-span-10 vx-flex vx-flex-col vx-w-full vx-justify-center vx-gap-2 md:vx-gap-8 lg:vx-max-w-screen-sm"
    >
        <vx-expandable-card>
            <template v-slot:content>
                <div :class="headingClasses">
                    <span>Details</span>
                    <vx-button v-if="allowEditContact" :href="`/contacts/${props.contactId}`" outline color="muted"
                        >Edit <font-awesome-icon :icon="faPen"></font-awesome-icon
                    ></vx-button>
                </div>
                <div :class="gridClasses">
                    <div :class="gridKeyClasses">Phone:</div>
                    <div :class="gridValueClasses">
                        {{ formatPhoneNumber(contact.phone) || '-' }}
                    </div>
                    <div :class="gridKeyClasses">First Name:</div>
                    <div :class="gridValueClasses">
                        {{ contact.first_name || '-' }}
                    </div>
                    <div :class="gridKeyClasses">Last Name:</div>
                    <div :class="gridValueClasses">
                        {{ contact.last_name || '-' }}
                    </div>
                    <div :class="gridKeyClasses">Email:</div>
                    <div :class="gridValueClasses">
                        {{ contact.email || '-' }}
                    </div>
                    <div :class="gridKeyClasses">Time-zone:</div>
                    <div :class="gridValueClasses">
                        {{ contact.time_zone || '-' }}
                    </div>
                    <div :class="gridKeyClasses">Added:</div>
                    <div :class="gridValueClasses">
                        {{ contact.created_at ? shortDateTime(contact.created_at) : '-' }}
                    </div>
                    <div :class="gridKeyClasses">Entry Point:</div>
                    <div :class="gridValueClasses">
                        {{ entryPoint(contact.entry_point) }}
                    </div>
                    <div :class="gridKeyClasses">Sticky Phone Number:</div>
                    <div :class="gridValueClasses">
                        <vx-icon-loading v-if="loadingStickyPhoneNumber" spin></vx-icon-loading>
                        <div v-else>
                            {{ stickyPhoneNumber ? formatPhoneNumber(stickyPhoneNumber.phone_number) : '-' }}
                        </div>
                    </div>
                </div>

                <contact-view-relationships :allowEditTags="allowEditTags"></contact-view-relationships>
            </template>
        </vx-expandable-card>
    </div>
</template>

<script setup>
import { VxExpandableCard, VxIconLoading, VxButton } from '@voxie/frontend-components';
import ContactViewRelationships from './view/ContactViewRelationships.vue';
import { useContactDetails } from './useContactDetails';
import { entryPoint, formatPhoneNumber } from '~/components/filters';
import { shortDateTime } from '~/utils/date';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPen } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    contactId: {
        type: Number,
        required: false,
    },
    allowEditContact: {
        type: Boolean,
        default: true,
    },
    allowEditTags: {
        type: Boolean,
        default: false,
    },
});

const headingClasses = 'vx-font-semibold vx-text-base vx-mb-2 vx-flex vx-items-center vx-justify-between';
const gridClasses =
    'vx-grid vx-grid-cols-12 vx-items-center vx-gap-y-2 vx-gap-x-1 vx-text-slate-800 vx-text-sm vx-mb-6';
const gridKeyClasses = 'vx-col-span-3 vx-break-all vx-text-xs vx-text-slate-500';
const gridValueClasses = 'vx-col-span-9 vx-break-all';

const {
    onMountedContact,
    contact,

    getStickyPhoneNumber,
    loadingStickyPhoneNumber,
    stickyPhoneNumber,

    getGroups,
    getSubscriptions,
    getTags,
    getCustomAttributes,
} = useContactDetails();

onMountedContact(() => {
    getStickyPhoneNumber();
    getGroups();
    getSubscriptions();
    getTags();
    getCustomAttributes();
});
</script>
